const getIsDeliverySenderFromBalticCountry = (countryFrom: string): boolean => {
    const BALTIC_LOCALES = ["LT", "LV", "EE"];
    return BALTIC_LOCALES.includes(countryFrom);
};
export default getIsDeliverySenderFromBalticCountry;
